import type { ReactNode } from 'react';
import { NavLink } from 'react-router';
import { NavbarLanguageSwitcher } from '~/components/ui/navbar-language-switcher';
import { PageContainer, SectionContainer } from '~/components/ui/container';

type LegalLayoutProps = {
  children: ReactNode;
};

export function LegalLayout({ children }: LegalLayoutProps) {
  return (
    <>
      <header className="border-border-200 border-b bg-background-0">
        <div className="flex items-center justify-between px-lg py-md">
          <NavLink to="/" className="flex items-center gap-sm">
            <img src="/favicon/favicon.svg" alt="Startable logo" className="size-8" />
            <span className="sr-only">Startable</span>
          </NavLink>
          <NavbarLanguageSwitcher />
        </div>
      </header>
      <PageContainer>
        <SectionContainer>{children}</SectionContainer>
      </PageContainer>
    </>
  );
}
